export function UPDATE_USER(state, data) {
  state.user = data
}

export function CLEAR_USER(state) {
  state.user = null
}
